"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Speaker = _interopRequireDefault(require("./Speaker"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    speakers: (0, _defineProperty2.default)({
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(1.5)
    }, theme.breakpoints.up('md'), {
      display: 'flex',
      flexWrap: 'wrap',
      paddingTop: theme.spacing(8)
    }),
    speakerWrapper: (0, _defineProperty2.default)({
      marginBottom: theme.spacing(4.5),
      '&:last-child': {
        marginBottom: theme.spacing(0)
      }
    }, theme.breakpoints.up('md'), {
      flex: '0 calc(50% - 20px)',
      '&:nth-child(odd)': {
        marginRight: theme.spacing(10)
      },
      '&:last-child': {
        marginBottom: theme.spacing(4.5)
      }
    })
  };
});
var SpeakerList = function SpeakerList(_ref) {
  var _ref$speakers = _ref.speakers,
    speakers = _ref$speakers === void 0 ? [] : _ref$speakers,
    defaultSpeakerImage = _ref.defaultSpeakerImage;
  var classes = useStyles();
  return __jsx("div", {
    className: classes.speakers
  }, speakers.map(function (speaker, index) {
    if (!speaker.image) speaker.image = defaultSpeakerImage;
    return __jsx("div", {
      className: classes.speakerWrapper,
      key: index
    }, __jsx(_Speaker.default, speaker));
  }));
};
var _default = SpeakerList;
exports.default = _default;